import axios from "axios";
import utils from '../config/utils';
// import VueCookies from 'vue-cookies';
// import store from '../store'
axios.defaults.withCredentials = true;  //允许跨域携带cookies

var HOST = '';
var IMG_SERVER = '';
var LOGIN_SERVER = ""; //信息服务中心登录
var APPS_SERVIER = ''; //信息服务中心api
var XUEXI_SERVER = ''; //新版在线学习
var XUEXI_HOST = '';//新版在线学习HOST
var StudyCode = ''; //研学旅行学校code
var HZ_CODE = ''; // 杭职院code

var JIAOYU_SCHOOL = ''; // 院校主页
if (process.env.NODE_ENV == 'development') {
  HOST = '';
  IMG_SERVER = 'http://yxt-api.43.dev.eol.com.cn';
  LOGIN_SERVER = "http://apps.66.dev.eol.com.cn";
  APPS_SERVIER = 'http://apps-api.66.dev.eol.com.cn';
  XUEXI_SERVER = 'http://xuexi-api.66.dev.eol.com.cn';
  XUEXI_HOST = 'http://xuexi.66.dev.eol.com.cn';
  JIAOYU_SCHOOL = 'http://yxt-student.43.dev.eol.com.cn';
  StudyCode = '100064';
  HZ_CODE = '100065';
} else {
  // 第二层判断打包后是测试环境还是正式环境 
  if (process.env.VUE_APP_FLAG === 'pro') {
    // 正式环境 
    HOST = 'https://api-yxt.jiaoyu.cn';
    IMG_SERVER = 'https://api-yxt.jiaoyu.cn';
    LOGIN_SERVER = "https://apps.jiaoyu.cn"; // eslint-disable-line no-unused-vars
    // APPS_SERVIER = 'https://apps-api.jiaoyu.cn'; 
    // XUEXI_SERVER = 'https://xuexi-api.jiaoyu.cn';
    XUEXI_HOST = 'https://szdj.hzvtc.edu.cn';
    APPS_SERVIER = 'https://szdj.hzvtc.edu.cn/apps-api';
    XUEXI_SERVER = 'https://szdj.hzvtc.edu.cn/xuexi-api';

    JIAOYU_SCHOOL = 'https://yxt.jiaoyu.cn';
    StudyCode = '100035';
    HZ_CODE = '100028';
  } else {
    // 测试环境 学校logo路径为passport
    HOST = 'http://yxt-api.43.dev.eol.com.cn';
    IMG_SERVER = 'http://yxt-api.43.dev.eol.com.cn';
    LOGIN_SERVER = "http://apps.66.dev.eol.com.cn"; // eslint-disable-line no-unused-vars
    APPS_SERVIER = 'http://apps-api.66.dev.eol.com.cn';
    XUEXI_SERVER = 'http://xuexi-api.66.dev.eol.com.cn';
    XUEXI_HOST = 'http://xuexi.66.dev.eol.com.cn';
    JIAOYU_SCHOOL = 'http://yxt-student.43.dev.eol.com.cn';
    StudyCode = '100064';
    HZ_CODE = '100065';
  }
}

function handleFunc (res) {
  // let pathname = window.location.pathname;
  if (res.code == '2001') {
    utils.removeUserInfo()
    let code = utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode")
    if (code) {
      // window.open(`${LOGIN_SERVER}/${code}/login?from=${window.location.href}`, "_self")
      window.open(`${APPS_SERVIER}/api/redirect?school_code=${code}&from=${window.location.href}`, "_self")
    }
  }
}

//请求发送拦截
axios.interceptors.request.use((request) => {
  return request;
}, function (error) {
  return Promise.reject(error);
});

const request = (method, url, params, needLogin) => {
  if (needLogin) params.login_sign = '';

  if (method == 'post') {
    return axios.post(url, params).then((res) => res.data).then((res) => {
      handleFunc(res);
      return res
    })
  } else if (method == 'get') {
    return axios.get(url, { params }).then((res) => res.data).then((res) => {
      handleFunc(res);
      return res
    })
  }
}
export default {
  IMG_SERVER: IMG_SERVER,
  HOST: HOST,
  LOGIN_SERVER: LOGIN_SERVER,
  APPS_SERVIER: APPS_SERVIER,
  XUEXI_SERVER: XUEXI_SERVER,
  XUEXI_HOST: XUEXI_HOST,
  JIAOYU_SCHOOL: JIAOYU_SCHOOL,
  StudyCode: StudyCode,
  HZ_CODE: HZ_CODE,
  //测评列表
  assessList (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam', params)
  },
  //测评记录
  assessLoglists (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam/record', params)
  },
  //测评详情
  assessGet (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam/' + params.id, params.data)
  },
  //用户测评答题卡
  assessCard (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam/card', params)
  },
  //测评试题查看
  questionGetbyassess (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam/question', params)
  },
  //提交测评
  assessModify (params) {
    return request('post', XUEXI_SERVER + '/api/my/tk/exam', params)
  },
  //测评结果页答题卡
  assessResultCard (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exam/mark_card', params)
  },
  //测评问答题评分
  assessScore (params) {
    return request('post', XUEXI_SERVER + '/api/my/tk/exam/' + params.id, params.data, true)
  },
  //学习中心-测评答题文件流下载
  assessFileGet (params) {
    let url = XUEXI_SERVER + "/api/my/tk/exam/download?"
    for (let key in params) {
      url += key + '=' + params[key] + '&'
    }
    return axios.request({
      url: url,
      responseType: 'blob',
      method: 'get'
    }).then((res) => res.data);
  },


  // V2.0接口
  // 信息服务中心 - 获取图片验证码
  getAppsImageCaptcha (params) {
    return request('get', APPS_SERVIER + '/api/captcha', params)
  },
  // 信息服务中心 - 获取短信验证码
  getAppsSmsCaptcha (params) {
    return request('get', APPS_SERVIER + '/api/sms/send', params)
  },
  // 信息服务中心 - 获取学校信息
  getAppsSchoolInfo (params) {
    return request('get', APPS_SERVIER + '/api/login/info', params)
  },
  // 信息服务中心 - 官网注册
  postAppsRegister (params) {
    return request('post', APPS_SERVIER + '/api/register', params)
  },
  // 信息服务中心 - 登录
  postAppsLogin (params) {
    return request('post', APPS_SERVIER + '/api/login', params)
  },
  // 信息服务中心 - 退出登录
  postAppsLogout (params) {
    return request('post', APPS_SERVIER + '/api/logout', params)
  },
  // 信息服务中心 - 修改个人密码
  postAppsEditPassword (params) {
    return request('post', APPS_SERVIER + '/api/user/password', params)
  },
  // 信息服务中心 - 重置密码
  postAppsResetPassword (params) {
    return request('post', APPS_SERVIER + '/api/reset', params)
  },
  // 信息服务中心 - 重置密码
  getAppsUserInfo (params) {
    return request('get', APPS_SERVIER + '/api/user/info', params)
  },
  // 信息服务中心 - 绑定/换绑手机号
  updateUserPhone (params) {
    return request('post', APPS_SERVIER + '/api/user/phone', params)
  },
  // 信息服务中心 - 解绑微信
  getWechatUnbind (params) {
    return request('post', APPS_SERVIER + '/api/user/unbind', params)
  },
  // 课程分类
  getCourseCategory (params) {
    return request('get', XUEXI_SERVER + '/api/course/category', params)
  },
  // 课程学习日志新增
  addCourseLog (params) {
    return request('get', XUEXI_SERVER + '/api/course/log/add', params)
  },
  // 课程章节详情
  getCourseChapterDetail (params) {
    return request('get', XUEXI_SERVER + '/api/course/' + params.id + '/chapter', params.data)
  },
  // 课程章节播放信息
  getCoursePlay (params) {
    return request('get', XUEXI_SERVER + '/api/course/course/' + params.id + '/play', params.data)
  },
  // 课程列表
  getCourseLists (params) {
    return request('get', XUEXI_SERVER + '/api/course/course', params)
  },
  // 课程详情
  getCourseDetails (params) {
    return request('get', XUEXI_SERVER + '/api/course/course/' + params.id, params.data)
  },
  // 课程讲师信息
  getCourseTeacher (params) {
    return request('get', XUEXI_SERVER + '/api/course/teacher', params)
  },
  // 课程详情-获取课程评价列表
  getCourseComment (params) {
    return request('get', XUEXI_SERVER + '/api/course/comment', params)
  },
  // 课程详情-添加课程评价
  addCourseComment (params) {
    return request('post', XUEXI_SERVER + '/api/course/comment', params)
  },
  // 课程详情-删除课程评价
  removeCourseComment (params) {
    return request('post', XUEXI_SERVER + '/api/course/comment/' + params.id, params.data)
  },
  // 课程详情-添加课程笔记
  addCourseNote (params) {
    return request('post', XUEXI_SERVER + '/api/my/course/note', params)
  },
  // 学习中心-我的课程列表
  getUserCourseList (params) {
    return request('get', XUEXI_SERVER + '/api/my/course', params)
  },
  // 学习中心-我的证书列表
  getUserCert (params) {
    return request('get', APPS_SERVIER + '/api/user/cert', params)
  },
  // 学习中心-我的笔记列表
  getUserCourseNote (params) {
    return request('get', XUEXI_SERVER + '/api/my/course/note', params)
  },
  // 学习中心-修改、删除我的笔记
  editUserCourseNote (params) {
    return request('post', XUEXI_SERVER + '/api/my/course/note/' + params.id, params.data)
  },
  // 学习中心-我的练习列表
  getUserExercisesList (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exercises', params)
  },
  // 学习中心-我的练习答题卡
  getUserExercisesCard (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exercises/card', params)
  },
  // 学习中心-我的练习答题卡
  getUserExercisesDetails (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exercises/' + params.id, params.data)
  },
  // 学习中心-我的练习题详情
  getUserExercisesQuestion (params) {
    return request('get', XUEXI_SERVER + '/api/my/tk/exercises/question', params)
  },
  // 学习中心-提交我的练习
  postUserExercisesSubmit (params) {
    return request('post', XUEXI_SERVER + '/api/my/tk/exercises', params)
  },
  // 学习中心-获取腾讯云视频上传签名
  tencentSign (params) {
    return request('get', XUEXI_SERVER + '/api/tencent/vod/sign', params)
  },
  // 学习中心-我的学习记录列表
  getUserLearnLog (params) {
    return request('get', XUEXI_SERVER + '/api/my/learn/log', params)
  },
  //课程资源pdf文件流下载v2
  courseFilePreview (params) {
    return axios.request({
      url: XUEXI_SERVER + "/api/course/course/preview",
      data: params,
      responseType: 'blob',
      method: 'post'
    }).then((res) => res.data);
  },
  //学习中心-练习文件流预览
  fileUpload (params) {
    return axios.request({
      url: XUEXI_SERVER + "/api/upload/file",
      method: 'post',
      data: params,
    }).then((res) => res.data);
  },
  //学习中心-练习答题文件流下载
  attachmentFileGet (params) {
    let url = XUEXI_SERVER + "/api/my/tk/exercises/attachment?"
    for (let key in params) {
      url += key + '=' + params[key] + '&'
    }
    return axios.request({
      url: url,
      responseType: 'blob',
      method: 'get'
    }).then((res) => res.data);
  },

  getStudyTrip (params) {
    return request('get', XUEXI_SERVER + '/api/yanxue/course/index', params)
  },
  getFamousClasses (params) {
    return request('get', XUEXI_SERVER + '/api/yanxue/course/index', params)
  },
  multiAide (params) {
    return request('get', XUEXI_SERVER + '/api/yanxue/material/index', params)
  },
  // 学习数据 - 学习概况
  getStudySummary (params) {
    return request('get', XUEXI_SERVER + '/api/my/stat/summary', params)
  },
  // 学习数据 - 学习课程统计
  getStudyCourse (params) {
    return request('get', XUEXI_SERVER + '/api/my/stat/report2', params)
  },
  // 学习数据 - 学习时长统计
  getStudyTime (params) {
    return request('get', XUEXI_SERVER + '/api/my/stat/report1', params)
  },
  // 获取课程分类
  getCategoryList (params) {
    return request('get', XUEXI_SERVER + '/api/sz/school/course/category', params)
  },
  // 获取课程列表
  getCourseList (params) {
    return request('get', XUEXI_SERVER + '/api/sz/school/course', params)
  },
  // 获取课程素材列表
  getCourseMaterial (params) {
    return request('get', XUEXI_SERVER + '/api/sz/school/course/list', params)
  },

  // 获取在线学习权限
  getXuexiUser (params) {
    return request('get', XUEXI_SERVER + '/api/user/info', params)
  }

}